

export const list = [
    {
        "label": "/",
        "value": "home",
    },
    {
        "label": "/about",
        "value": "about",
        "sub": [
            {
                "label": "/about1",
                "value": "about1"
            },
            {
                "label": "/about2",
                "value": "about2"
            },
            {
                "label": "/about3",
                "value": "about3"
            }
        ]
    },
    {
        "label": "/cms",
        "value": "CMS",
    },
    {
        "label": "/things",
        "value": "things",
        "sub": [
            {
                "label": "/things1",
                "value": "things1"
            },
            {
                "label": "/things2",
                "value": "things2"
            },
            {
                "label": "/things3",
                "value": "things3"
            }
        ]
    },
    {
        "label": "/stuff",
        "value": "stuff",
        "sub": [
            {
                "label": "/foo",
                "value": "Foo"
            },
            {
                "label": "/stuff2",
                "value": "stuff2"
            },
            {
                "label": "/stuff3",
                "value": "stuff3"
            }
        ]
    },
    {
        "label": "/contact",
        "value": "contact"
    }
]
